export class PlanFinal {
    public idHeader: string;
    public totalVolumeTons: number;
    public totalVolumeEuroDurance: number;
    public totalVolumeYearBefore: number;
    public totalGifts: number;
    public avgGiftCost: number;
    public costPPE: number;
    public incidenceKg: number;
    public incidenceLiter: number;
    public incidenceEuro: number;
    public budgetIncidence: number;
    public evaluationMark: number;
    public notes: string;
    public mrkHeadNotes: string;
    public mrkMngSign: string;
    public mrkHeadSign: string;
    public status: number;
    public currentVersion: [];
    public statusDescription: string;
    public grossProfit: number

    constructor(
        idHeader?: string,
        totalVolumeTons?: number,
        totalVolumeEuroDurance?: number,
        totalVolumeYearBefore?: number,
        totalGifts?: number,
        avgGiftCost?: number,
        costPPE?: number,
        incidenceKg?: number,
        incidenceLiter?: number,
        incidenceEuro?: number,
        budgetIncidence?: number,
        evaluationMark?: number,
        notes?: string,
        mrkHeadNotes?: string,
        mrkMngSign?: string,
        mrkHeadSign?: string,
        status?: number,
        currentVersion?: [],
        statusDescription?: string,
        grossProfit?: number
    ) {
        this.idHeader = idHeader;
        this.totalVolumeTons = totalVolumeTons;
        this.totalVolumeEuroDurance = totalVolumeEuroDurance;
        this.totalVolumeYearBefore = totalVolumeYearBefore;
        this.totalGifts = totalGifts;
        this.avgGiftCost = avgGiftCost;
        this.costPPE = costPPE;
        this.incidenceKg = incidenceKg;
        this.incidenceLiter = incidenceLiter;
        this.incidenceEuro = incidenceEuro
        this.budgetIncidence = budgetIncidence;
        this.evaluationMark = evaluationMark;
        this.notes = notes;
        this.mrkHeadNotes = mrkHeadNotes;
        this.mrkMngSign = mrkMngSign;
        this.mrkHeadSign =mrkHeadSign;
        this.status = status;
        this.currentVersion = currentVersion;
        this.statusDescription = statusDescription;
        this.grossProfit = grossProfit;
    }
}